<template>
  <button
    type="button"
    class="accruals-option-row"
    :class="{ 'accruals-option-row--disabled': disabled }"
    :data-testid="`accruals-page__option-${id}`"
    :disabled="disabled"
    @click="onClick"
  >
    <span class="accruals-option-row__left">
      <span class="accruals-option-row__icon-wrap">
        <img :src="icon" alt="" class="accruals-option-row__icon" />
      </span>
      <span class="accruals-option-row__text">
        <span class="accruals-option-row__title-row">
          <span class="accruals-option-row__title">{{ title }}</span>
          <span v-if="badge" class="accruals-option-row__badge">{{ badge }}</span>
        </span>
        <span v-if="subtitle" class="accruals-option-row__subtitle">{{ subtitle }}</span>
      </span>
    </span>
  </button>
</template>

<script>

export default {
  name: 'AccrualsOptionRow',
  emits: ['click'],
  props: {
    id: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    icon: { type: String, required: true },
    badge: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    onClick(event) {
      if (event && typeof event.stopPropagation === 'function') {
        event.stopPropagation();
      }
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AccrualsOptionRow.scss';
</style>
